import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EncrDecrService } from '../../services/encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class EmailsService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

  sendEmails(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post('https://events.globalistic.tech/api/admin/sendEmail', data, { headers: headers_object }).toPromise();
  }

  getAllEmails(){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get('https://events.globalistic.tech/api/admin/bulkemails', { headers: headers_object }).toPromise();
  }
}
